/**
 * 子智能体调用卡片组件 (Re-export shim)
 *
 * 功能已迁移到 ai-elements/tool-cards/SubagentCard.tsx
 * 此文件保留以维持向后兼容性
 *
 * @module SubagentInvocationCard
 */

import React from 'react';
import {
  SubagentCardFromInvocation,
  type SubagentInvocationData as SubagentInvocationDataType,
  type SubagentToolCall as SubagentToolCallType,
} from '../ai-elements/tool-cards/SubagentCard';

export type SubagentToolCall = SubagentToolCallType;
export type SubagentInvocationData = SubagentInvocationDataType;

export interface SubagentMessage {
  role: 'assistant' | 'tool';
  content?: string;
  tool_name?: string;
  timestamp: string;
}

export interface SubagentInvocationCardProps {
  data: SubagentInvocationData;
  onClose?: () => void;
}

export const SubagentInvocationCard: React.FC<SubagentInvocationCardProps> = ({
  data,
  onClose: _onClose,
}) => {
  return <SubagentCardFromInvocation data={data} />;
};

export default SubagentInvocationCard;
